<template>
  <div class="info">
    <div class="body">
      <div class="box1" style="width: 100%;">
        <el-row type="flex" justify="center" style="margin-bottom: 50px">
          <el-col :span="22">
            <div class="title">I want to sign up (only one type can be selected at a time)</div>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-col :span="20">
            <div class="all" style="width: 100%;border: 1px solid #eee">
              <el-row>
                <el-table
                    :data="tableData"
                    style="width: 100%;">
                  <el-table-column
                      prop="policyName"
                      label="Type"
                      width="140">
                  </el-table-column>
                  <el-table-column
                      prop="startTime"
                      label="StartTime"
                  >
                  </el-table-column>
                  <el-table-column
                      prop="endTime"
                      label="EndTime"
                  >
                  </el-table-column>
                  <el-table-column
                      prop="fee"
                      width="100"
                      label="UnitPrice"
                  >
                  </el-table-column>
                  <el-table-column
                      prop="num"
                      label="Num"
                      width="200"
                  >
                    <template slot-scope="scope">
                      <el-input-number v-model="scope.row.num" :min="0"
                                       :max="scope.row.surplus>=0?scope.row.surplus:9999"
                                       :disabled="!scope.row.disabled || scope.row.surplus===0"
                                       @change="getTotal(scope.row.num,scope.row.fee,scope.row);"></el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="surplus"
                      label="Number of current users remaining available for registration"
                      width="120"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.surplus >= 0 ? scope.row.surplus - scope.row.num : 9999 }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="total"
                      label="total"
                      width="120"
                  >
                    <template slot-scope="scope">
                      <span v-model="scope.row.total">{{ scope.row.total }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>
              <el-row style="margin: 25px">
                <el-col :offset="22" :span="2">
                  <span style="color: #1da7fe !important">￥{{ this.allTotal }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-button style="width: 100%;height: 50px;font-size: 18px" @click="toSign" v-preventReClick
                             :disabled="totalNum===0" type="primary">I want to sign up
                  </el-button>
                </el-col>
              </el-row>

            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "signUpBody",
  data() {
    return {
      id: '',
      policyId: '',
      allTotal: 0,
      totalNum: 0,
      tableData: [
        {
          disabled: false
        },]
    }
  },
  methods: {
    getTotal(a, b, scopeRow) {
      return scopeRow.total = a * b
    },
    getAllTotal() {
      let alltotal = 0;
      let totalNum = 0;
      for (let i = 0; i < this.tableData.length; i++) {
        alltotal += this.tableData[i].total
        totalNum += this.tableData[i].num
      }
      this.allTotal = alltotal
      this.totalNum = totalNum
      // console.log(this.totalNum);
    },
    changeDisabled() {
      if (this.totalNum !== 0) {
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].num === 0) {
            this.tableData[i].disabled = false
          }
          if (this.tableData[i].num !== 0) {
            this.policyId = this.tableData[i].policyId
          }
        }
      }
      if (this.totalNum === 0) {
        for (let i = 0; i < this.tableData.length; i++) {
          this.tableData[i].disabled = true
        }
      }
    },
    async toSign() {
      const {data: res} = await this.$http.post('api/conference/pay/confOrderNo', {
        policyId: this.policyId,
        quantity: this.totalNum
      })
      // console.log(res);
      if (res.code === 200) {
        let orderNo = res.result.orderNo
        let amount = res.result.amount
        let routeData = this.$router.resolve(
            {
              path: '/signUpForm',
              query: {
                orderNo: orderNo,
                amount: amount,
                totalNum: this.totalNum,
                confId: this.id,
                policyId: this.policyId
              }
            });
        window.open(routeData.href, '_blank');
      } else {
        this.$message.error(res.msg)
      }

    },

    async getPayInformation(id) {
      const {data: res} = await this.$http.post('api/conference/confPolicy/allList/' + id)
      if (res.code === 200) {
        console.log(res);
        this.tableData = res.data
      } else {
        this.$message.error(res.msg)
      }

    }
  },
  watch: {
    tableData: {
      handler() {
        this.getAllTotal()
        this.changeDisabled()
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.id = this.$route.query.id
    this.getPayInformation(this.id)
  }
}
</script>

<style scoped lang="less">
.info{
  display: flex;
  flex-direction: column;
}
.body {
  min-height: 220px;
  background-color: white;
  //width: 1200px;
  margin: 0 auto;
}

.title {
  font-size: 18px;
  width: 100%;
  height: 35px;
  line-height: 35px;
  padding-left: 10px;
  color: #1da7fe;
  border-left: solid 6px #1da7fe !important;
  border-right: solid 3px #1da7fe !important;
  background-color: #fbfbfb;
}
</style>
